import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import Avatar from '../ui/Avatar';
import Section from './Section';
import SidebarNavShell from './SidebarNavShell';
import SidebarPrimaryNav from './SidebarPrimaryNav';
import { useSidebarNav } from '../../hooks/useUserPreferences';
import { useNavigationMode } from './hooks/useNavigationMode';

function SidebarNavigationSkeleton() {
  const { mode } = useNavigationMode();
  const { sidebarNavPreferences, setSidebarNavSectionOpen } = useSidebarNav();

  return (
    <SidebarNavShell
      ariaBusy
      footer={
        <div className="side-item-footer" data-testid="sidebar-footer-skeleton">
          <div className="side-nav-footer-inner">
            <div className="side-nav-footer-profile">
              <Avatar className="side-nav-footer-avatar" alt={t`Profile`} />
              <div className="side-nav-footer-name-skeleton" aria-hidden />
              <span className="sr-only">
                <Trans>Loading profile</Trans>
              </span>
            </div>
          </div>
        </div>
      }
    >
      <SidebarPrimaryNav mode={mode} />

      <Section
        title={t`Tags`}
        isOpen={sidebarNavPreferences.sections.tags}
        onToggle={(isOpen) => setSidebarNavSectionOpen('tags', isOpen)}
      >
        <ul id="tags" className="list-reset" aria-label={t`Tags`} />
      </Section>

      <Section
        title={t`Folders`}
        isOpen={sidebarNavPreferences.sections.folders}
        onToggle={(isOpen) => setSidebarNavSectionOpen('folders', isOpen)}
      >
        <ul id="folders" className="list-reset" aria-label={t`Folders`} />
      </Section>
    </SidebarNavShell>
  );
}

export default SidebarNavigationSkeleton;
